import React from "react";
import { displayPhotoUrl } from "@/lib/photo";

const AVATAR_COLORS = ["#007BFF", "#28A745", "#FF8C00", "#8A2BE2", "#E91E8C", "#17A2B8", "#FFC107", "#6C757D"];
const SELISE_COLORS = ["#1e3a8a", "#2563eb", "#3b82f6", "#1e293b", "#475569", "#64748b", "#334155", "#60a5fa"];

function getInitials(name) {
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  return name.substring(0, 2).toUpperCase();
}

function getColor(name, palette) {
  const hash = name.split("").reduce((acc, c) => acc + c.charCodeAt(0), 0);
  return palette[hash % palette.length];
}

// Static (non-context) version of CollaboratorBadges for the pixel-perfect export view.
export default function CollaboratorBadgesExport({ collaboratorIds, allPeople, theme }) {
  const palette = theme === "selise" || theme === "dark" ? SELISE_COLORS : AVATAR_COLORS;
  const ids = collaboratorIds || [];
  if (ids.length === 0) return null;

  const people = (allPeople || []).filter((p) => ids.includes(p.id));
  const visible = people.slice(0, 3);
  const remaining = people.length - visible.length;

  return (
    <div className="flex items-center -space-x-1.5 flex-shrink-0" title={`Functional Leaders: ${people.map((p) => p.name).join(", ")}`}>
      {visible.map((p) => (
        <div
          key={p.id}
          className="w-4 h-4 rounded-full flex items-center justify-center text-white text-[7px] font-bold flex-shrink-0 overflow-hidden"
          style={{ backgroundColor: displayPhotoUrl(p.photo_url) ? "transparent" : getColor(p.name || "?", palette) }}
          title={p.name}
        >
          {displayPhotoUrl(p.photo_url) ? (
            <img src={displayPhotoUrl(p.photo_url)} alt={p.name} className="w-full h-full object-cover" />
          ) : (
            getInitials(p.name || "?")
          )}
        </div>
      ))}
      {remaining > 0 && (
        <div className="w-4 h-4 rounded-full flex items-center justify-center text-gray-600 text-[7px] font-bold flex-shrink-0 bg-gray-100">
          +{remaining}
        </div>
      )}
    </div>
  );
}